/**
 * The type of the action which sets the user-facing NKF-AEC ON/OFF state.
 *
 * {
 *     type: SET_NKF_AEC_ENABLED,
 *     enabled: boolean
 * }
 */
export const SET_NKF_AEC_ENABLED = 'SET_NKF_AEC_ENABLED';
/**
 * The type of the action which shows/hides the NKF-AEC debug waveform overlay
 * (the "スピーカー" toolbar button — same as the floating top-left waveform button).
 *
 * {
 *     type: SET_NKF_DEBUG_OVERLAY,
 *     visible: boolean
 * }
 */
export const SET_NKF_DEBUG_OVERLAY = 'SET_NKF_DEBUG_OVERLAY';
/**
 * The type of the action which shows/hides the NKF-AEC debug LOG panel
 * (the "ログ" item moved into the 詳細な操作 menu).
 *
 * {
 *     type: SET_NKF_LOG_PANEL,
 *     visible: boolean
 * }
 */
export const SET_NKF_LOG_PANEL = 'SET_NKF_LOG_PANEL';
/**
 * The type of the action which reports whether echo cancellation has actually
 * reached a working state (delay found / echo measurably suppressed).
 *
 * This is observation only — nothing in the audio path reads it. It exists so
 * we can tell, from a real meeting, whether "not ready yet" lines up with the
 * echo loops users report right after joining.
 *
 * {
 *     type: SET_NKF_AEC_READY,
 *     ready: boolean,
 *     reason: string
 * }
 */
export const SET_NKF_AEC_READY = 'SET_NKF_AEC_READY';
/**
 * The type of the action which starts/stops the deliberate main-thread jank
 * used to reproduce the transmitted-audio dropouts.
 *
 * Debug tool — see nkf-aec/jank.ts.
 *
 * {
 *     type: SET_NKF_JANK,
 *     running: boolean
 * }
 */
export const SET_NKF_JANK = 'SET_NKF_JANK';
/**
 * 音量の自動調整(メイクアップゲイン)の入切。
 *
 * {
 *     type: SET_NKF_MAKEUP_GAIN,
 *     enabled: boolean
 * }
 */
export const SET_NKF_MAKEUP_GAIN = 'SET_NKF_MAKEUP_GAIN';
/**
 * 送信メーター(周波数つき)の表示切替。
 *
 * {
 *     type: SET_NKF_TX_METER,
 *     open: boolean
 * }
 */
export const SET_NKF_TX_METER = 'SET_NKF_TX_METER';
/**
 * The type of the action which shows/hides the media stats panel
 * (main-thread pressure next to the transmitted-audio dropout rate).
 *
 * {
 *     type: SET_NKF_MEDIA_STATS,
 *     open: boolean
 * }
 */
export const SET_NKF_MEDIA_STATS = 'SET_NKF_MEDIA_STATS';
/**
 * The type of the action which sets the share of chunks bypassed on purpose
 * (debug: reproduces the processed/raw alternation without needing overload).
 *
 * {
 *     type: SET_NKF_FORCE_BYPASS,
 *     pct: number
 * }
 */
export const SET_NKF_FORCE_BYPASS = 'SET_NKF_FORCE_BYPASS';
/**
 * The type of the action which reports that the echo delay is known but the
 * microphone is still held silent for the grace period.
 *
 * Distinct from SET_NKF_AEC_READY: to the far side both states are silence, but
 * only one of them means "we still have no idea where the echo is".
 *
 * {
 *     type: SET_NKF_AEC_SETTLING,
 *     reason: string
 * }
 */
export const SET_NKF_AEC_SETTLING = 'SET_NKF_AEC_SETTLING';
